<template>
  <div class="commentReport" @click="data.show = false">
    <div class="body" @click.stop="">
      <div class="font-16-333 title">举报评论</div>
      <div class="font-14-666 text">
        <span>@{{ item.nickname }}：{{ item.content }}</span>
      </div>
      <div class="layout-row but-body">
        <div
          class="but"
          :class="{ this: selectIndex == index }"
          v-for="(item, index) of list"
          :key="index"
          @click="selectTap(index)"
        >
          {{ item.tags_name }}
        </div>
      </div>

      <div class="sub" :class="{ select: selectIndex != -1 }" @click="sub()">
        提交
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["data"],
  data() {
    return {
      selectIndex: -1,
      list: [],
      note: {
        show: false,
      },
      item: {},
    };
  },
  created() {
    this.item = this.data.item;
    this.post_report_tags();
  },
  methods: {
    selectTap(index) {
      if (this.selectIndex == index) {
        this.selectIndex = -1;
      } else {
        this.selectIndex = index;
      }
    },
    sub() {
      if (this.selectIndex == -1) {
        this.$toast.center("请选择举报内容");
        return;
      }
      this.data.show = false;
      // comment_id	是	int	评论id
      // type	是	int	类型(1:题库 2:视频 3:经验 4:答疑 5:考点狂背 6:帖子 7：题单里面 8:题单外面)
      // tags_id	是	int	举报原因id
      // content	否	string	举报内容
      this.$axios
        .post("/comment/add_report", {
          tab_key: this.item.tab_key,
          content: this.item.content,
          type: 1,
          comment_id: this.item.comment_id,
          tags_id: this.list[this.selectIndex].tags_id,
          // note_id: data.note_id,
          //           comment_id
        })
        .then((res) => {
          if (res.code == 200) {
          }
        });
    },
    post_report_tags() {
      let report_tags = localStorage.getItem("report_tags");
      if (report_tags) {
        this.list = JSON.parse(report_tags);
        return;
      }
      this.$axios.post("/comment/report_tags").then((res) => {
        if (res.code == 200) {
          this.list = res.data.list;
          localStorage.setItem("report_tags", JSON.stringify(res.data.list));
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.commentReport {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba($color: #000000, $alpha: 0.4);
  display: flex;
  .body {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #fff;
    .title {
      height: 2.5rem;
      line-height: 2.5rem;
      text-align: center;
      width: 100%;
    }
    .text {
      padding: 0.65rem 0.75rem;
      box-sizing: border-box;
      margin: 0 auto 1rem auto;
      width: calc(100% - 1.5rem);
      height: 3.25rem;
      background: #f6f6f6;
      span {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
      }
    }
    .but-body {
      padding-left: 0.75rem;
      flex-wrap: wrap;
      div {
        margin: 0 0.75rem 0.75rem 0;
        padding: 0 10px;
        text-align: center;
        height: 1.75rem;
        line-height: 1.75rem;
        background: #f6f6f6;
        border-radius: 0.2rem;
        font-size: 12px;
        color: #333;
      }
      .this {
        color: #fff;
        background: #3982f7;
      }
    }
    .sub {
      margin: 0.75rem auto 1.5rem auto;
      width: 16.5rem;
      text-align: center;
      height: 2.2rem;
      line-height: 2.2rem;
      background: #c0d8ff;
      border-radius: 1.1rem;
      font-size: 0.8rem;
      color: #fff;
    }
    .select {
      background: #3982f7;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/comment/Report.vue